import React from "react";
import { MenuList } from "../helpers/MenuList";
import MenuItem from "../components/MenuItem";
import "../styles/Menu.css";
import { motion } from "framer-motion";

const Menu = () => {
  return (
    <motion.div
      className="menu"

       initial={{ width: 0, y: 30, scale: 0.95 }}
      animate={{ width: "100vw", y: 0, scale: 1 }}
      exit={{ x: window.innerWidth, y: -20, scale: 0.95 }}
      transition={{
        duration: 0.6,
        ease: [0.25, 0.8, 0.25, 1] 
      }}
    >
      <h1 className="menuTitle">Our Menu</h1>
      <div className="menuList">
        {MenuList.map(({ id, image, name, price }) => (
          <MenuItem
            key={id}
            image={image}
            name={name}
            price={price}
          />
        ))}
      </div>
    </motion.div>
  );
};

export default Menu;
